import { ReactNode } from 'react';

import { ActionIcon, AppShell, Tooltip } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

import classes from './PageAside.module.css';

interface PageAsideProps {
  title: string;
  children: ReactNode;
  opened: boolean;
  onClose: () => void;
  onOpen: () => void;
}

export function PageAside({ title, children, opened, onClose, onOpen }: Readonly<PageAsideProps>) {
  return (
    <>
      <AppShell.Aside className={classes.aside} withBorder={false}>
        <div className={classes.header}>
          <h3 className={classes.title}>{title}</h3>
          <Tooltip label="Hide panel" position="left">
            <ActionIcon variant="subtle" color="navy" onClick={onClose} aria-label="Hide panel">
              <IconChevronRight size={18} />
            </ActionIcon>
          </Tooltip>
        </div>
        <div className={classes.body}>{children}</div>
      </AppShell.Aside>
      {!opened && (
        <button
          type="button"
          className={classes.reopenTab}
          onClick={onOpen}
          aria-label={`Show ${title}`}
        >
          <IconChevronLeft size={14} />
          {title}
        </button>
      )}
    </>
  );
}
